import React from "react";

const Row = ({ label, value, highlight }) => (
  <div style={{ display: "flex", justifyContent: "space-between",
    alignItems: "center", padding: "7px 0",
    borderBottom: "0.5px solid #f0f1f3" }}>
    <span style={{ fontSize: 12.5, color: "#5a6070" }}>{label}</span>
    <span style={{
      fontSize: 13, fontWeight: 500,
      color: highlight ? "#1a9e78" : "#1a1e2e",
    }}>
      {value}
    </span>
  </div>
);

const StatusSummary = ({ data }) => (
  <div style={{ background: "#fff", border: "0.5px solid #e2e4e8",
    borderRadius: 10, overflow: "hidden" }}>
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between",
      padding: "10px 14px", borderBottom: "0.5px solid #e2e4e8", background: "#f5f6f8" }}>
      <span style={{ fontSize: 13, fontWeight: 500, color: "#1a1e2e" }}>Status Summary</span>
      <span style={{ fontSize: 10, color: "#8a909e" }}>As of {data.asOf}</span>
    </div>
    <div style={{ padding: "4px 14px 10px" }}>
      <Row label="Total Cards"        value={data.totalCards}  highlight />
      <Row label="Due response (NEW)" value={data.dueResponse} />
      <Row label="Accepted"           value={data.accepted}    />
      <Row label="Deferred"           value={data.deferred}    />
      <Row label="Rejected"           value={data.rejected}    />
      <Row label="Executed"           value={data.executed}    />
      <Row label="Expired"            value={data.expired}     />
    </div>
  </div>
);

export default StatusSummary;